import { useI18n } from "@/lib/i18n";
import { Link } from "@tanstack/react-router";

export function FoundersWord() {
  const { lang, t } = useI18n();
  return (
    <section className="mx-auto max-w-[44rem] px-5 py-16 md:py-20">
      <article className="rounded-sm border border-border bg-card/40 p-6 sm:p-8">
        <div className="mb-5 flex items-center justify-between gap-4 text-[10px] uppercase tracking-[0.2em] text-muted-foreground">
          <span>Entry № 0001</span>
          <span>{lang === "ru" ? "Голос основателя" : "Founder's Word"}</span>
        </div>
        <div className="logbook-rule mb-6" />
        <h2 className="font-display text-2xl sm:text-3xl">{t.founder_heading}</h2>
        <div className="dropcap mt-5 space-y-4 text-[1.02rem] leading-[1.75]">
          {lang === "ru" ? (
            <>
          <p className="text-justify">
            Я ушёл в море молодым. Меня выучила советская морская академия и
            воспитали традиции, которые Россия столетия назад приняла от
            голландского и английского флотов. Я ходил под капитанами, за
            которыми пошёл бы в любой шторм.
          </p>
          <p className="text-justify">
                Поэтому нет — этот сайт не против капитанов, стармехов или старпомов.
                Он за них: за каждого, кто несёт власть без жестокости. Безумие в
                нашем названии — не должность. Это то, во что превращается власть
                над зависимыми людьми, когда она становится инструментом унижения и
                давления.
              </p>
            </>
          ) : lang === "zh" ? (
            <>
              <p className="text-justify">
                我很年轻时就开始出海，在一所苏联航海学院受训。我的职业传统，来自俄罗斯几百年前从荷兰和英国舰队继承来的海上规矩。我也曾遇到过真正的好船长——那种我愿意跟着他进入任何风暴的人。
              </p>
              <p className="text-justify">
                所以，不——这个网站不是反对船长、轮机长或高级船员。它站在他们一边：站在每一个掌握权力、却不把权力变成残酷的人一边。
              </p>
              <p className="text-justify">
                这里的 "mad"，不是一种职务，也不是一个军衔。它指的是一种变化：当权力压在依赖你的人身上，变成羞辱、压迫，变成每天悄无声息地吞食别人痛苦的工具时，发生的那种变化。
              </p>
            </>
          ) : (
            <>
          <p className="text-justify">
            I went to sea young. I was trained in a Soviet maritime academy and
            brought up on traditions that Russia inherited, centuries ago, from
            the Dutch and the English fleets. I have served under masters I
            would follow into any storm.
          </p>
          <p className="text-justify">
                So no — this site is not against captains, chief engineers, or
                chief officers. It stands for them: for everyone who carries
                authority without cruelty. The madness in our name is not a rank.
                It is what happens when power over dependent people turns into a
                tool — of humiliation, of pressure, of quiet daily feeding on
                another man's distress.
              </p>
            </>
          )}
        </div>
        <p className="mt-6 text-sm italic text-muted-foreground">{t.founder_sig}</p>
        <p className="mt-6 text-sm">
          <Link
            to="/$lang/about"
            params={{ lang }}
            className="underline-offset-4 hover:underline"
            style={{ color: "var(--amber)" }}
          >
            {lang === "ru"
              ? "Читать полностью →"
              : lang === "zh"
                ? "阅读全文 →"
                : "Read the full text →"}
          </Link>
        </p>
      </article>
    </section>
  );
}